import React from "react";
import {
  makeStyles,
  Box,
  IconButton,
  Dialog,
  Typography,
  Button,
  Backdrop,
} from "@material-ui/core";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import { getLang } from "app/feature/constants";
import SnAvailabilityListTable from "../../table/snAvailabilityListTable";
import DefaultImg from "assets/img/img-default.png";

const useStyle = makeStyles((theme) => ({
  header: {
    padding: "12px 16px",
    borderBottom: "1px solid #D0D5DD",
  },
  formField: {
    display: "grid",
    gridTemplateColumns: "1fr 3fr",
    gridColumnGap: theme.spacing(1),
  },
  attributeText: {
    color: "#b2b2b2",
    fontSize: 12,
    whiteSpace: "break-spaces",
  },
  productPhoto: {
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #E4E7EC",
    width: 50,
    height: 50,
    borderRadius: 4,
    "& img": {
      height: "100%",
      width: "100%",
      borderRadius: 4,
    },
  },
}));

export default function AssignConfirmationDialogComponent({
  isOpen,
  handleClose,
  handleSubmit,
  lang,
  assignInfo,
}) {
  const classes = useStyle();

  return (
    <Dialog
      maxWidth={"md"}
      open={isOpen}
      onClose={() => {}}
      aria-labelledby="modal-assign-serial-number-to-product"
      aria-describedby="modal-assign-serial-number-to-product"
      BackdropComponent={Backdrop}
      fullWidth
      PaperProps={{
        style: {
          overflowY: "hidden",
        },
      }}
    >
      <Box
        className={classes.header}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="body1">
          <b>{getLang(lang, "label.ASSIGN_SERIAL_NUMBER_CONFIRMATION")}</b>
        </Typography>
        <IconButton
          onClick={handleClose}
          edge="end"
          size="small"
          aria-label="close dialog"
        >
          <CloseRoundedIcon color="primary" />
        </IconButton>
      </Box>
      <Box>
        <Box px={2.5} mt={2}>
          <Typography variant="body1">
            {getLang(lang, "paragraph.ASSIGN_SN_CONFIRMATION_MESSAGE")}
          </Typography>
        </Box>
        <Box className={classes.formField} px={2.5} mt={3}>
          <Typography variant="body1" color="textSecondary">
            {getLang(lang, "label.PRODUCT")}
          </Typography>
          <Box display="flex" alignItems="center" gridGap={8}>
            {!!assignInfo?.product?.picture && (
              <Box className={classes.productPhoto}>
                {!assignInfo?.product?.picture ? (
                  <img src={DefaultImg} alt="emptyProduct" />
                ) : (
                  <img
                    src={assignInfo.product.picture}
                    alt={assignInfo.product.name}
                  />
                )}
              </Box>
            )}
            <Box>
              <Typography variant="body1">
                {assignInfo?.product?.name || "-"}
              </Typography>
              {!!assignInfo?.product?.attribute &&
                !!assignInfo.product.attribute.length && (
                  <Typography className={classes.attributeText} variant="body2">
                    {assignInfo.product.attribute
                      .map((a) => a.options)
                      .join(", ")}
                  </Typography>
                )}
            </Box>
          </Box>
        </Box>
        <Box className={classes.formField} px={2.5} mt={2}>
          <Typography variant="body1" color="textSecondary">
            {getLang(lang, "label.BRANCH")}
          </Typography>
          <Typography variant="body1">
            {assignInfo?.branch?.name || "-"}
          </Typography>
        </Box>
        <Box>
          <SnAvailabilityListTable
            handleReload={() => {}}
            isPreview={true}
            format={assignInfo?.format}
            activeType={assignInfo?.activeType}
          />
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        style={{ background: "white" }}
        p={2}
      >
        <Button
          variant="outlined"
          type="button"
          color="primary"
          onClick={handleClose}
        >
          {getLang(lang, "label.CANCEL")}
        </Button>
        &ensp;
        <Button
          variant="contained"
          color="secondary"
          type="button"
          onClick={handleSubmit}
        >
          {getLang(lang, "label.CONFIRM")}
        </Button>
      </Box>
    </Dialog>
  );
}
